import { enqueueSnackbar } from 'notistack';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

class NotificationService {
  private static instance: NotificationService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  public show(message: string, type: NotificationType = 'info', hideDuration = 3000) {
    enqueueSnackbar(message, { variant: type, autoHideDuration: hideDuration });
  }

  public success(message: string) {
    this.show(message, 'success');
  }

  public error(message: string, duration = 3000) {
    this.show(message, 'error', duration);
  }

  public warning(message: string) {
    this.show(message, 'warning');
  }

  public info(message: string) {
    this.show(message, 'info');
  }
}

export default NotificationService.getInstance();
